import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import Admin from './pages/Admin';
import AvailabilityManager from './pages/AvailabilityManager';
import TestimonialsManager from './pages/TestimonialsManager';
import Testimonials from './pages/Testimonials';
import { Toaster } from './components/ui/sonner';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/testimonials" element={<Testimonials />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/admin/availability" element={<AvailabilityManager />} />
          <Route path="/admin/testimonials" element={<TestimonialsManager />} />
        </Routes>
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;